import { Controller } from "stimulus";
import Turbolinks from "turbolinks";

export default class extends Controller
{
    static targets = ["submit"];

    SITE_GROUPS = [];
    SITE_TYPES = [];
    REGIONS = [];
    TIME_ZONES = [];

    connect()
    {   
        this.submitTarget.addEventListener("click", e =>
        {
            if(!this.validate(this.element)) e.preventDefault();


        })
    }

    validate(form)
    {
        let pass = true;

        let requiredFields = Array.from(form.querySelectorAll(`input`)).filter(x => x.required && x.dataset.validation);

        for(let i = 0; i<requiredFields.length; i++)
        {
            let field = requiredFields[i];
            if(!field.value)
            {
                let message = field.dataset["validation"];
                let event = new CustomEvent("show-toast", { detail: "An error occurred:\n"+message });
                window.dispatchEvent(event);

                pass = false;
                break;
            }
        }

        return pass;
    }

    handleEdit(event)
    {
        if (event.detail[0] && !event.detail[0].success)
        {
            const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred: " + event.detail[0].error })
            window.dispatchEvent(errorEvent);
        }
        else
        {
            let { active_dev_num, site_num } = event.detail[0];

            const success = new CustomEvent("show-toast", { detail: "Site successfully created!" })
            window.dispatchEvent(success)
            Turbolinks.visit(window.App.prefixedUrl(`/sites/${site_num}?active_dev_num=${active_dev_num}`))
        }
    }

}